import "./general.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export default function Nav() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Fermer le menu quand on clique sur un lien
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  // Empêcher le scroll quand le menu est ouvert
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  return (
    <>
      <div className="Nav">
        <nav className="Nav_section">
          <li>
            <Link to="/">
              <img
                className="Nav_logo"
                src="https://maelcorp.com/favicon.ico"
                alt="Logo Maelcorp"
              />
            </Link>
          </li>

          <li className="Nav_desktop_item">
            <Link to="/services">
              <p className="nav-link-text">
                <span>{"[" + t("nav.services") + "]"}</span>
                <span>{"[" + t("nav.services") + "]"}</span>
              </p>
            </Link>
          </li>

          <li className="Nav_desktop_item">
            <Link to="/projects">
              <p className="nav-link-text">
                <span>{"[" + t("nav.projects") + "]"}</span>
                <span>{"[" + t("nav.projects") + "]"}</span>
              </p>
            </Link>
          </li>

          <li className="Nav_desktop_item">
            <Link to="/contact">
              <p className="nav-link-text">
                <span>{"[" + t("nav.contact") + "]"}</span>
                <span>{"[" + t("nav.contact") + "]"}</span>
              </p>
            </Link>
          </li>

          <li className="Nav_section--connect Nav_desktop_item">
            <ul>
              <li>
                <a
                  href="https://www.instagram.com/maelcorporation/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <p className="nav-link-text">
                    <span>[ig]</span>
                    <span>[ig]</span>
                  </p>
                </a>
              </li>
              <li>
                <a
                  href="https://fr.linkedin.com/company/maelcorp"
                  target="_blank"
                  rel="noreferrer"
                >
                  <p className="nav-link-text">
                    <span>[li]</span>
                    <span>[li]</span>
                  </p>
                </a>
              </li>
            </ul>
          </li>

          {/* Burger button pour mobile uniquement */}
          <button
            className={`Nav_burger ${isMenuOpen ? "active" : ""}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>

      {/* Menu mobile overlay */}
      <div className={`Nav_mobile_overlay ${isMenuOpen ? "active" : ""}`}>
        <ul className="Nav_mobile_menu">
          <li>
            <Link to="/" onClick={handleLinkClick}>
              <p className="nav-link-text">
                <span>{"[" + t("nav.home") + "]"}</span>
              </p>
            </Link>
          </li>

          <li>
            <Link to="/services" onClick={handleLinkClick}>
              <p className="nav-link-text">
                <span>{"[" + t("nav.services") + "]"}</span>
              </p>
            </Link>
          </li>

          <li>
            <Link to="/projects" onClick={handleLinkClick}>
              <p className="nav-link-text">
                <span>{"[" + t("nav.projects") + "]"}</span>
              </p>
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={handleLinkClick}>
              <p className="nav-link-text">
                <span>{"[" + t("nav.contact") + "]"}</span>
              </p>
            </Link>
          </li>

          {/* <li>
            <button onClick={handleLinkClick}>
              <p className="nav-link-text">
                <span>{"[" + t("nav.contact") + "]"}</span>
              </p>
            </button>
          </li> */}

          <li className="Nav_mobile_socials">
            <a
              href="https://www.instagram.com/maelcorporation/"
              target="_blank"
              rel="noreferrer"
              onClick={handleLinkClick}
            >
              <p className="nav-link-text">
                <span>[instagram]</span>
              </p>
            </a>
            <a
              href="https://fr.linkedin.com/company/maelcorp"
              target="_blank"
              rel="noreferrer"
              onClick={handleLinkClick}
            >
              <p className="nav-link-text">
                <span>[linkedin]</span>
              </p>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
